import container from "../../libs/container/container";
import binder from '../../libs/utils/binder';
import preloader from "../../libs/preloader/preloader";

const amdAboutMissionModule = (function () {
    const name = 'about__mission-module';

    const view = container.getBaseView(name);

    view.privateVars = {
        currentTab: null
    }

    view.startup = function () {

        preloader.init();
        preloader.setPreloadBulk(name, view.publicVars.preloadTab);

        view.privateVars.currentTab = 'mission';

        // container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutMissionLabelNavItemMissionCls, 'animate__fadeInDown50P', name, {
        //     dynamicPosHeight: true
        // });
        // container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutMissionLabelNavItemVisionCls, 'animate__fadeInDown50P', name, {
        //     dynamicPosHeight: true
        // });

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutMissionHeaderBigCls, 'animate__bounce', name, {
            dynamicPosHeight: true
        });

        const missionItems = document.querySelectorAll(view.publicVars.cssId.anim.moduleAboutMissionMissionTabItemCls);

        for(let i = 1; i <= missionItems.length; i++) {
            container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutMissionMissionTabItemCls + i, 'animate__zoomIn50P', name, {
                dynamicPosHeight: true
            });
        }

        const visionItems = document.querySelectorAll(view.publicVars.cssId.anim.moduleAboutMissionVisionTabItemCls);

        for(let i = 1; i <= visionItems.length; i++) {
            container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutMissionVisionTabItemCls + i, 'animate__zoomIn50P', name, {
                dynamicPosHeight: true
            });
        }
    };

    view.bind = function () {

        binder.bindToAll('click', view.publicVars.cssId.moduleAboutMissionLabelNavItemCls, function() {

            if(view.privateVars.currentTab !== this.dataset.tab) {
                view.methods.actionToggleTab(this.dataset.tab);
            }
        });
    };

    view.methods = {
        actionToggleTab: (tab) => {
            binder.executeForAll(view.publicVars.cssId.moduleAboutMissionLabelNavItemCls, function(item) {
                item.classList.remove(view.publicVars.cssId.isActiveCls.substring(1));
            });

            document.querySelector(view.publicVars.cssId.moduleAboutMissionLabelNavItemCls + '-' + tab).classList.add(view.publicVars.cssId.isActiveCls.substring(1));

            document.querySelector(view.publicVars.cssId.moduleAboutMissionTabCls + '-' + view.privateVars.currentTab).classList.remove(view.publicVars.cssId.isActiveCls.substring(1));
            document.querySelector(view.publicVars.cssId.moduleAboutMissionTabCls + '-' + tab).classList.add(view.publicVars.cssId.isActiveCls.substring(1));

            container.getService('scroll').refreshScroll();

            view.privateVars.currentTab = tab;
        }
    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdAboutMissionModule;